import { useEffect, useState } from "react";
import Checkers from "../../../../../../helpers/class/Checkers";
import BedroomCard from "./BedroomCard";
import RightModal from "../../../../properties/partials/RightModal";
import ContentWrapper from "../../../../properties/partials/ContentWrapper";
import BedroomsContentWrapper from "../../../../properties/partials/BedroomsContentWrapper";
import { SwiperSlide } from "swiper/react";

const BedroomData = (props) => {

    const [modalState, setModalState] = useState("close");

    const handleShow = (type, bedroomId) => {
        if (type === 'bedroomModal') {
            const foundBedroom = props.bedroom.bedroom_id === bedroomId;
            if (foundBedroom) {
                setModalState(type + (bedroomId != null ? bedroomId : ''));

            }
        }
    };

    const handleHide = () => {
        setModalState("close");
    }

    const stripHtml = (html: string) => {
        let doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    }

    const media = props.bedroom.media;

    const imagesArray = [];
    if (Checkers.isValidArray(media)) {
        for (let i = 0; i < media.length; i++) {
            imagesArray.push(media[i].image)
        }
    }

    return (
        <>
            <div className={"Properties Properties-Thumb Properties-Border Properties-Shadow flex-grow-1 mb-3 property-room-types"}>

                <BedroomCard
                    bedroom={props.bedroom}
                    bedroom_id={props.bedroom.bedroom_id}
                    bedroom_title={props.bedroom.bedroom_title}
                    bedrooms={props.bedroom.capacity_max}
                    description={stripHtml(props.bedroom.description)}
                    images={imagesArray}
                    handleShow={() => handleShow('bedroomModal', props.bedroom.bedroom_id)}
                    isHotel={true}
                    prices={props.prices}
                    galleryRef={props.galleryRef}
                    galleryHeight={props.galleryHeight}
                />
            </div>

            {props.bedroom && <RightModal
                key={100}
                modalName={'bedroomModal' + props.bedroom.bedroom_id}
                className="slide_right"
                Title={props.bedroom.bedroom_title}
                modalSize="lg"
                loaderStatus={false}
                closeModal={() => {
                    handleHide()
                }}
                show={modalState === 'bedroomModal' + props.bedroom.bedroom_id}
                BodyRender={<ContentWrapper ContentRender={
                    <>
                        <BedroomsContentWrapper data={props.bedroom} />
                    </>
                } />}
            />}
        </>
    )
}

export default BedroomData